import React from 'react';
import { Box, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import get from 'lodash/get';

export const FormikAutocompleteMultiple = ({
  field,
  form,
  disabled,
  inputProps,
  options,
  label,
  getSelectedValue,
}: any): React.ReactElement => {
  const textLabel = label;
  const isInvalid = get(form.errors, field.name) && (get(form.touched, field.name) || form.submitCount > 0);
  const onTextInputChange = (input: string) => {
    if(input && input.length > 0) {
      inputProps.onInputChange(input);
    }
  }
  const onSelect = (value:any) => {
    if(value.length) {
      getSelectedValue(value)
    }
  }
  return (
    <Box display='flex' flexDirection='column'>
      <Autocomplete
        // @ts-ignore
        multiple
        fullWidth
        onChange={(e, value) => onSelect(value)}
        getOptionSelected={(option, selected) => {
          // @ts-ignore
          return selected?.id === option.id;
        }}
        getOptionLabel={(option) => {
          // @ts-ignore
          if (!option.name) {
            return '';
          }
          // @ts-ignore
          return `${option.name}`;
        }}
        disabled={disabled}
        options={options}
        value={field.value}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              error={isInvalid}
              helperText={isInvalid && get(form.errors, field.name)}
              variant='outlined'
              label={textLabel}
              margin='dense'
              onChange={(e) => onTextInputChange(e.target.value)}
            />
          );
        }}
      />
    </Box>
  );
}